import './styles.scss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Well from 'Components/layout/Well';
import Input from 'Components/forms2/Input';
import ErrorMessage from 'Components/forms2/ErrorMessage';

export default class MissionCostEstimationIndustryForm extends Component {
    static propTypes = {
        title: PropTypes.string,
        tip: PropTypes.string,
        state: PropTypes.shape({
            industry: PropTypes.string
        }).isRequired,
        onStateChange: PropTypes.func.isRequired,
        errors: PropTypes.arrayOf(
            PropTypes.shape({
                field: PropTypes.string.isRequired,
                message: PropTypes.string.isRequired
            })
        ).isRequired
    };
    static defaultProps = {};

    render() {
        const { title, state, onStateChange, tip, errors } = this.props;
        const { industry } = state;
        const validationErrors = errors.filter(error => ['industry'].includes(error.field));

        return (
            <div className="component-mission-cost-estimation-industry-form">
                <Well
                    title={title}
                    tipBody={tip}
                >
                    <Input
                        name="industry"
                        placeholder="Type your industry"
                        required={true}
                        value={industry}
                        onChange={onStateChange}
                    />
                    {validationErrors.map(validationError => (<ErrorMessage key={validationError.field} message={validationError.message} />))}
                </Well>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/public/missionCostEstimation/IndustryForm/index.js